export const PAYMENT_LINK_IMAGES = {
  MODAK_LOGO: {
    src: '/assets/icons/modak-logo-grey.svg',
    alt: 'Modak Payment Link Logo',
    width: '127px',
    height: '24px',
  },
  MODAK_WEBSITE_COMPOSITE: {
    src: '/assets/images/etc/modak-website-composition-banking.webp',
    alt: 'Modak Website Composite',
    width: 220,
    height: 220,
  },
  MODAK_WEBSITE_V2_COMPOSITE: {
    src: '/assets/images/pages/payment-link-success-composition.webp',
    alt: 'Modak Website Composite',
    width: 320,
    height: 187,
  },

  ROBOT_ERROR: {
    src: '/assets/images/etc/robot-error.svg',
    alt: 'Robot Error',
    width_mobile: 197,
    height_mobile: 160,
    width_desktop: 296,
    height_desktop: 240,
  },
  LINK_USED: {
    src: '/assets/images/etc/payment-link-used.webp',
    alt: 'Payment link used',
    width_mobile: 197,
    height_mobile: 160,
    width_desktop: 296,
    height_desktop: 240,
  },
  FOOTER: {
    src: '/assets/images/pages/payment-link-footer.webp',
    alt: 'Footer Image',
    width: '343px',
    height: '46px',
  },
  FOOTER_V2: {
    src: '/assets/images/pages/payment-link-v2-brands.svg',
    alt: 'Footer Image',
    width: '654px',
    height: '54px',
  },
  FOOTER_V2_MOBILE: {
    src: '/assets/images/pages/payment-link-v2-brands-mobile.svg',
    alt: 'Footer Image',
    width: '343px',
    height: '685px',
  },
};

export const CPaymentLinkStatuses = {
  VALID: 'VALID',
  USED: 'USED',
  NOT_VALID: 'NOT_VALID',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
} as const;

export const PaymentLinkUtm = {
  Medium: {
    Success: 'Payment_Success',
    Completed: 'Payment_Already_Completed',
    Invalid: 'Payment_Invalid',
  },
  Campaign: {
    QR: 'PaymentLink_QR',
    LINK: 'PaymentLink_Link',
    Unknown: 'PaymentLink_Unknown',
  },
  Amount: 10,
  CODE: 'PAYMENT25',
};

export const PaymentLinkV2Campaign = {
  AMOUNT: 10,
  CODE: 'FAMILYCARD',
};
